import { useMemo } from 'react';
import { JobStatus, PostingFlows } from 'Douleutaras/types';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { jobSelectors } from 'Douleutaras/redux/data/jobs/jobsSlice';
import { selectMe } from 'Douleutaras/redux/data/users/meSlice';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import { useLocalization } from 'Douleutaras/hooks/localization';

export const useJobExtraBidState = (jobId: string) => {
  const job = useAppSelector(state => jobSelectors.selectById(state, jobId));
  const me = useAppSelector(selectMe);
  const { countryCode } = useLocalization();

  return useMemo(() => {
    if (!job || !me) {
      return {};
    }

    const isCleaning = parseInt(job.relationships.category.data.id, 0) === COUNTRY_CONFIG.CLEANING_CATEGORY[countryCode];
    const isLegacyFlow = job.attributes.postingFlow !== PostingFlows.PROS_LIST || !me.prosListExtraBidFlowEnabled;

    return {
      bidsCount: job.relationships.bids.meta.count,
      isLegacyFlow,
      isExtraBidVisible: job.attributes.postingFlow !== PostingFlows.DIRECT
        && job.attributes.status !== JobStatus.CANCELLED
        && !isCleaning,
      isExtraBidDisabled: !job.attributes.canAskMoreBids
    };
  }, [job?.id, me?.prosListExtraBidFlowEnabled]);

};
